export interface SystemSupplierTabViewModel {
    suppliers: Array<SystemSupplierTabRowViewModel>;
}

export interface SystemSupplierTabRowViewModel {
    id: string;
    name: string;
    type: SystemSupplierType;
    countryCode: string;
    agreements: Array<SupplierAgreementViewModel>;
    contracts: Array<SupplierContractViewModel>;
    hasDataProcessorAgreement: boolean;
    containsNotAccessibleDocuments: boolean;
    containsNotAccessibleContracts: boolean;
    isLink: boolean;
    supplierName: string | null;
}

export interface SupplierAgreementViewModel {
    documentId: string;
    name: string;
    fileName: string | null;
    link: string | null;
    dataId: string | null;
}

export interface SupplierContractViewModel {
    id: string;
    name: string;
}

export interface SystemSupplierTabTableViewModel extends SystemSupplierTabRowViewModel {
    typeString: string;
    countryString: string;
}

export enum SystemSupplierType {
    Supplier = 1,
    SubContractor = 2,
}
